import { usersApi } from 'entities/users/model/usersApi';
import { LanguageType } from 'shared/types';

const getLanguagesApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getLanguages: builder.query<LanguageType[], string | null>({
      query: () => '/account/admin/dicts/languages/',
    }),
  }),
});

export const { useGetLanguagesQuery } = getLanguagesApi;
